var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"value":_vm.value,"editor-toolbar":_vm.customToolbar},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }